import { library } from '@fortawesome/fontawesome-svg-core';

import { 
  faTachometerAlt, 
  faTrash, 
  faPlus, 
  faPencilAlt, 
  faFileExcel,
  faChevronDown,
  faClipboardList, 
  faPaste, 
  faInfoCircle, 
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faCreditCard,
  faUpload,
  faHandPointer,
  faQuestionCircle,
  faCalendarAlt,
  faChevronUp,
  faWrench,
  faTimes,
  faSync,
  faSearch,
  faSearchPlus,
  faCaretRight,
  faBars,
  faUserCircle,
  faGlobeAmericas,
  faUniversity,
  faUserCog,
  faUserEdit,
  faUserPlus,
  faDollarSign,
  faBullhorn,
  faEnvelope,
  faBook,
  faTag,
  faCog,
  faStickyNote,
  faFilePdf,
  faCubes,
  faExternalLinkAlt,
  faRss,
  faRssSquare,
  faCaretDown,
  faExclamationCircle,
  faPlusSquare,
  faAlignJustify,
  faFileAlt
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faTachometerAlt, 
  faTrash, 
  faPlus, 
  faPencilAlt, 
  faFileExcel,
  faChevronDown,
  faClipboardList, 
  faPaste, 
  faInfoCircle, 
  faPencilAlt, 
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faCreditCard,
  faUpload,
  faHandPointer,
  faQuestionCircle,
  faCalendarAlt,
  faChevronUp,
  faWrench,
  faTimes,
  faSync,
  faSearch,
  faSearchPlus,
  faCaretRight,
  faBars,
  faUserCircle,
  faGlobeAmericas,
  faUniversity,
  faUserCog,
  faUserEdit,
  faUserPlus,
  faDollarSign,
  faBullhorn,
  faEnvelope,
  faBook,
  faTag,
  faCog,
  faStickyNote,
  faFilePdf,
  faCubes,
  faExternalLinkAlt,
  faRss,
  faRssSquare,
  faCaretDown,
  faExclamationCircle,
  faPlusSquare,
  faAlignJustify,
  faFileAlt
);
